import { produce } from 'immer';
import { TABLE_CLOSE, TABLE_CLOSE_ALL, TABLE_INIT, TABLE_UPDATE } from './tables.action-types';
var initialState = [];
/**
 * Tables reducer.
 *
 * @author Mikhail Siutsou
 * @category Reducers
 * @subcategory Tables
 * @param {TableState} state state.
 * @param {ActionsTypes} action action.
 * @return {TableState[]} modals state.
 */

var tablesReducer = function tablesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case TABLE_INIT:
      {
        return produce(state, function (draft) {
          var _action$payload;

          var idx = state.findIndex(function (grid) {
            return grid.tableId === action.payload.tableId;
          });
          var tableState = {
            tableId: action.payload.tableId,
            items: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.items) || null,
            isError: !!action.payload.isError,
            isLoading: !!action.payload.isLoading,
            page: action.payload.number || 0,
            totalElements: action.payload.totalElements || 0,
            numberOfElements: action.payload.numberOfElements || 0,
            totalPages: action.payload.totalPages || 10,
            size: action.payload.size || 10,
            search_value: action.payload.search_value || '',
            sorts: action.payload.sorts || [],
            filters: action.payload.filters || []
          };

          if (idx >= 0) {
            draft[idx] = tableState;
          } else {
            draft.push(tableState);
          }
        });
      }

    case TABLE_UPDATE:
      {
        return produce(state, function (draft) {
          var _action$payload2, _draft$idx;

          var idx = state.findIndex(function (grid) {
            return grid.tableId === action.payload.tableId;
          });

          if (idx < 0) {
            return;
          }

          var tableState = {
            tableId: action.payload.tableId,
            items: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.items) || ((_draft$idx = draft[idx]) === null || _draft$idx === void 0 ? void 0 : _draft$idx.items) || null,
            isError: typeof action.payload.isError !== 'undefined' ? action.payload.isError : draft[idx].isError,
            isLoading: typeof action.payload.isLoading !== 'undefined' ? action.payload.isLoading : draft[idx].isLoading,
            page: typeof action.payload.number !== 'undefined' ? action.payload.number : draft[idx].page,
            totalElements: typeof action.payload.totalElements !== 'undefined' ? action.payload.totalElements : draft[idx].totalElements,
            numberOfElements: typeof action.payload.numberOfElements !== 'undefined' ? action.payload.numberOfElements : draft[idx].numberOfElements,
            totalPages: typeof action.payload.totalPages !== 'undefined' ? action.payload.totalPages : draft[idx].totalPages,
            size: typeof action.payload.size !== 'undefined' ? action.payload.size : draft[idx].size,
            search_value: typeof action.payload.search_value === 'string' ? action.payload.search_value : draft[idx].search_value,
            sorts: action.payload.sorts || draft[idx].sorts,
            filters: action.payload.filters || draft[idx].filters
          };

          if (idx >= 0) {
            draft[idx] = tableState;
          }
        });
      }

    case TABLE_CLOSE:
      {
        return produce(state, function (draft) {
          var idx = state.findIndex(function (table) {
            return table.tableId === action.payload.tableId;
          });
          if (idx !== -1) draft.splice(idx, 1);
        });
      }

    case TABLE_CLOSE_ALL:
      {
        return [];
      }

    default:
      {
        return state;
      }
  }
};

export default tablesReducer;